module.exports = __webpack_public_path__ + "static/media/Scape_Tool.bf4f3e1a.svg";